
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/academy/learn-crypto-trading",
      function () {
        return require("private-next-pages/academy/learn-crypto-trading/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/academy/learn-crypto-trading"])
      });
    }
  